import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormPopupComponent } from 'src/app/modules/request-form/pages/form-popup/form-popup.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getSegmentOptions } from 'src/app/shared/helpers/Drop-down-options';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { PortDetailsService } from 'src/app/shared/service/port-details/port-details.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { VoyageRequestsService } from 'src/app/shared/service/voyage-requests/voyage-requests.service';

@Component({
  selector: 'app-zn-requestform',
  templateUrl: './zn-requestform.component.html',
  styleUrls: ['./zn-requestform.component.scss']
})
export class ZnRequestformComponent {
  requestForm!: FormGroup;
  formSubmitted: boolean = false;
  clientOptions = ['ZeroNorth'];
  portNameSuggestions: any[] = [];
  filteredPortNames: any[] = [];
  shipyardOptions = ['TBD'];
  typeofshipOptions = [
    'Bulk Carrier',
    'Chem Tanker',
    'Container',
    'General CArgo',
    'Oil Tanker',
    'Tanker',
  ];
  merakiPicOptions = [
    { label: 'ALS - Alexroger', value: 'ALS' },
    { label: 'HAJ - Hancy', value: 'HAJ' },
    { label: 'HAS - Harshi', value: 'HAS' },
    { label: 'KER - Keerthana', value: 'KER' },
    { label: 'INV - Indhirani', value: 'INV' },
    { label: 'MAL - Malini', value: 'MAL' },
    { label: 'PHJ - Philomina', value: 'PHJ' },
    { label: 'PRA - Priya', value: 'PRA' },
    { label: 'RAS - Rajeswari', value: 'RAS' },
    { label: 'SAG - Santhosh', value: 'SAG' },
    { label: 'SOS - Souta Samanta ', value: 'SOS' },
    { label: 'BHY - Bhargavi', value: 'BHY' },
    { label: 'NAB - Nancy', value: 'NAB' },
    { label: 'TST - Test', value: 'TST' },
  ];
  weatherSourceOptions = [
    // { label: 'Weather Service -1', value: 'stormglass' },
    { label: 'DTN', value: 'DTN' },

  ];
  eigerPicOptions = [
    { label: 'SAKA - Satish', value: 'SAKA' },
    { label: 'SABA - Sandokan', value: 'SABA' },
    { label: 'ROAK - Roman', value: 'ROAK' },
    { label: 'AAHA - Ahmet', value: 'AAHA' },
    { label: 'NIAL - Nikita', value: 'NIAL' },
    { label: 'JESH - Jeet', value: 'JESH' },
    { label: 'RAPA - Rahul', value: 'RAPA' },
    { label: 'AHKM - Abhishek', value: 'AHKM' },
    { label: 'SAMH - Sadique Muhammad', value: 'SAMH' },
  ]
  segmentOptions: any;
  typeOfSpeedOptions = [
    { label: 'Constant Speed', value: 'CP Speed' },
    // {
    //   label: 'Optimal Speed(Reefer container)',
    //   value: 'Optimal Speed(Reefer container)',
    // },
    // { label: 'Optimal Speed', value: 'Optimal Speed',disabled: true },
  ];
  voyageTypeOptions = [
    { label: 'Laden', value: 'Laden' },
    { label: 'Ballast', value: 'Ballast' },
  ];
  templetOptions = [
    { label: 'Weather Report', value: 'weather_report' },
    // { label: 'Ballast', value: 'Ballast' },
  ];
  reportTypeOptions = [
    { label: 'Mid Voyage', value: 'MID' },
    { label: 'End Voyage', value: 'END' },
  ];
  yesNo = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  yesNoDayPositive = [
    { label: 'Yes', value: 'all_day_positive' },
    { label: 'No', value: 'no' },
  ];
  duelFuelOptions = [
    { label: 'Yes', value: 'excluded' },
    { label: 'No', value: 'included' },
  ];
  adverseCurrentValue = [
    { label: 'Yes', value: 'x' },
    { label: 'No', value: 'inc' },
  ];
  yesNo3 = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
    { label: 'N/A', value: 'Not Applicable' },
  ];
  wetherCalculationOptions = [
    { label: 'BF Only', value: 'BF' },
    { label: 'DSS', value: 'DSS' },
    { label: 'SWH', value: 'SWH' },
    { label: 'SWH&DSS', value: 'SWH+DSS' },
    // { label: 'Wind Wave & Swell Height', value: 'Wind Wave & Swell Height' },
  ];
  performanceCalOptions = [
    { label: 'Voyage', value: 'Voyage' },
    // { label: 'Daily', value: 'Daily',disabled: true },
  ];
  goodWeatherPeriod = [12, 15, 18, 24];
  windBeaufort = [2, 3, 4, 5, 6];
  fuelType = ['ULSFO', 'VLSFO', 'HSFO', 'MDO', 'LNG', 'OTHERS', 'NA'];
  selectedFile!: File;
  selectedMainCPFile!: File;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  @ViewChild('fileUpload') fileUpload: ElementRef | undefined;
  datesValidator: boolean = false;
  latDir = ['N', 'S'];
  longDir = ['E', 'W'];
  id: any;
  reportGenerate: boolean = false;
  mainCpFile: boolean = false;
  dataToPass: any;
  json_string: any;
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService,
    private router: Router,
    private portDetails: PortDetailsService,
    private dialog: MatDialog,
    private overlayService: OverlapService,
    private voyageRequestsService: VoyageRequestsService
  ) {
    this.requestForm = this.fb.group({
      ship: ['', Validators.required],
      imoNumber: ['', Validators.required],
      voyNumber: [''],
      segment: [''],
      typeOfShip: [''],
      merakiPic: [''],
      eigerPic: [''],
      shipYard: [''],
      yearBuilt: [''],
      pFrom: ['', Validators.required],
      pTo: ['', Validators.required],
      etaDate: [''],
      etaHours: [''],
      etaMinutes: [''],
      cosp: [''],
      cospHours: [''],
      cospMinutes: [''],
      eosp: [''],
      eospHours: [''],
      eospMinutes: [''],
      client: ['ZeroNorth', Validators.required],
      weatherSource: ['DTN', Validators.required],
      templet: [''],
      typeSpeed: ['', Validators.required],
      voyageType: ['', Validators.required],
      reportType: ['', Validators.required],
      cpOrderedSpeed: ['', Validators.required],
      allDayPositive: ['',],
      multipleSpeed: [false],
      fuelType: ['', Validators.required],
      fuelTypeOne: ['', Validators.required],
      fuelTypeTwo: ['', Validators.required],
      cpFuel: [''],
      cpFuelOne: [''],
      cpOthers: [''],
      aboutSc: ['', Validators.required],
      windBeaufort: ['', Validators.required],
      windWave: ['', Validators.required],
      swellHeight: ['', Validators.required],
      significantWave: ['', Validators.required],
      adverseCurrent: ['', Validators.required],
      currentFactor: ['', Validators.required],
      periodiccurrentfactor: ['', Validators.required],
      currentOnlyNeg: [''],
      adverseSwellEx: [''],
      hoursNeedToBeCon: [false],
      goodWeatherPeriod: ['', Validators.required],
      performanceCal: ['', Validators.required],
      excludeFirst: [''],
      excludeLast: [''],
      speedMinTol: ['', Validators.required],
      speedMaxTol: ['', Validators.required],
      consMinTol: ['', Validators.required],
      consMaxTol: ['', Validators.required],
      extrapolationMethod: ['', Validators.required],
      wetherCalculation: ['', Validators.required],
      secaEca: [''],
      duelFuel: ['', Validators.required],
      cpGasOil: [''],
      bfLimitDss: ['', Validators.required],
      // mainCp: ['', Validators.required],
      currLat: [''],
      currLng: [''],
      latDir: [''],
      longDir: [''],
      repWindBf: [''],
      repSwell: [''],
      repAvgSpeed: [''],
      voyAvgSpeed: [''],
      mainCp: ['', [this.maxWordsValidator()]],
      mainCpFile: [''],
      additionalComments: [''],
      id: [''],
      useNewCurrentFormula: ['NO'],
      updatedAt: [''],
      status: [''],
      has_mid_voyage: [false],
      lock_until_date: ['']
    });
    this.requestForm.get('client')?.valueChanges.subscribe((value) => {
      console.log('condition', this.requestForm.value);
      if (value === 'Eiger') {
        this.requestForm.patchValue({ periodiccurrentfactor: 'NO' });
      } else {
        this.requestForm.patchValue({ periodiccurrentfactor: 'YES' });
      }
    });
    this.segmentOptions = getSegmentOptions();
  }

  ngOnInit() {
    this.voyageRequestsService.prefillData$.subscribe((prefill) => {
      if (prefill) {
        this.requestForm.patchValue({
          ship: prefill.vesselName || '',
          imoNumber: prefill.imo || '',
          typeOfShip: prefill.vesselType || '',
          voyNumber: prefill.voyageRef || '',
          yearBuilt: prefill.yearBuilt || '',
          pFrom: prefill.startPort || '',
          pTo: prefill.endPort || '',
          voyageType: prefill.condition || 'Laden',
          cpOrderedSpeed: prefill.speed || '',
          aboutSc: prefill.speedRemarks || '',
          windBeaufort: prefill.maxWind ? Math.min(6, Math.max(2, Math.round(prefill.maxWind / 6))) : 4,
          windWave: prefill.maxWave || '',
          significantWave: prefill.maxWave || '',
          secaEca: prefill.secaFuel ? 'YES' : 'NO',
        });
        if (prefill.startLat != null) {
          this.requestForm.patchValue({
            currLat: Math.abs(prefill.startLat),
            latDir: prefill.startLatDir || (prefill.startLat >= 0 ? 'N' : 'S')
          });
        }
        if (prefill.startLong != null) {
          this.requestForm.patchValue({
            currLng: Math.abs(prefill.startLong),
            longDir: prefill.startLongDir || (prefill.startLong >= 0 ? 'E' : 'W')
          });
        }
      }
    });

    this.sharedDataService.fleetViewRowData$.subscribe((data) => {
      this.id = data?.id;
      if (data?.id) {
        this.reportGenerate = true;
        this.mainCpFile = true;
        const cospDate = data.cosp.split(' ');
        const eospDate = data.eosp.split(' ');
        const ETAdate = data.etaDate.split(' ');
        this.requestForm.patchValue(data);
        if (data.hoursNeedToBeCon === 'false') {
          this.requestForm.get('hoursNeedToBeCon')?.setValue(false);
        } else {
          this.requestForm.get('hoursNeedToBeCon')?.setValue(true);
        }
        if (data.multipleSpeed === 'false') {
          this.requestForm.get('multipleSpeed')?.setValue(false);
        } else {
          this.requestForm.get('multipleSpeed')?.setValue(true);
        }
        this.requestForm.get('cosp')?.setValidators(Validators.required);
        this.requestForm.get('cospHours')?.setValidators(Validators.required);
        this.requestForm.get('cospMinutes')?.setValidators(Validators.required);
        this.requestForm.get('eosp')?.setValidators(Validators.required);
        this.requestForm.get('eospHours')?.setValidators(Validators.required);
        this.requestForm.get('eospMinutes')?.setValidators(Validators.required);
        this.requestForm.get('client')?.setValue(data.client_name);
        this.requestForm.get('fuelTypeOne')?.setValue(data.fueltypeone);
        this.requestForm.get('fuelTypeTwo')?.setValue(data.fueltypetwo);
        this.requestForm.get('cpGasOil')?.setValue(data.cpgasoil);
        this.requestForm.get('bfLimitDss')?.setValue(data.bflimitdss);
        this.requestForm.get('currLng')?.setValue(Math.abs(data.long));
        this.requestForm.get('currLat')?.setValue(Math.abs(data.lat));
        this.requestForm.get('eigerPic')?.setValue(data.eigerpic);
        this.requestForm.get('weatherSource')?.setValue(data.weatherSource);
        let lat = data.lat;
        if (lat !== '') {
          let direction = lat < 0 ? 'S' : 'N';
          this.requestForm.get('latDir')?.setValue(direction);
        }

        let long = data.long;
        if (long !== '') {
          let lonDir = long < 0 ? 'W' : 'E';
          this.requestForm.get('longDir')?.setValue(lonDir);
        }

        this.requestForm.get('repWindBf')?.setValue(data.repWindBf);
        this.requestForm.get('repSwell')?.setValue(data.repSwell);
        this.requestForm.get('repAvgSpeed')?.setValue(data.repAvgSpeed);
        this.requestForm.get('voyAvgSpeed')?.setValue(data.voyAvgSpeed);
        this.requestForm
          .get('periodiccurrentfactor')
          ?.setValue(data.periodiccurrentfactor);
        this.requestForm.get('etaDate')?.setValue(ETAdate[0]);
        this.requestForm.get('etaHours')?.setValue(ETAdate[1]?.split(':')[0]);
        this.requestForm.get('etaMinutes')?.setValue(ETAdate[1]?.split(':')[1]);
        this.requestForm.get('cosp')?.setValue(cospDate[0]);
        this.requestForm.get('cospHours')?.setValue(cospDate[1]?.split(':')[0]);
        this.requestForm
          .get('cospMinutes')
          ?.setValue(cospDate[1]?.split(':')[1]);
        this.requestForm.get('eosp')?.setValue(eospDate[0]);
        this.requestForm.get('eospHours')?.setValue(eospDate[1]?.split(':')[0]);
        this.requestForm
          .get('eospMinutes')
          ?.setValue(eospDate[1]?.split(':')[1]);
        this.datesValidator = true;
      }
    });
    this.portDetails.getPortDetails().subscribe((response: any) => {
      this.filteredPortNames = response?.data ?? [];
    });

    // this.requestForm.get('mainCp')?.valueChanges.subscribe(value => {
    //   const wordCount: number = value.trim().split(/\s+/).length;

    //   if (wordCount > 3) {
    //     // Truncate the value to the first three words
    //     const truncatedValue: string = value.trim().split(/\s+/).slice(0, 3).join(' ');
    //     this.requestForm.get('mainCp')?.setValue(truncatedValue, { emitEvent: false });

    //   }
    // });
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  onInputChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 30) {
      inputElement.value = currentValue.slice(0, 30);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onVoyageChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 10) {
      inputElement.value = currentValue.slice(0, 10);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    const maxLength = 4;
    if (numericValue.length > maxLength) {
      inputElement.value = numericValue.slice(0, maxLength);
    } else {
      inputElement.value = numericValue;
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  numberInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    inputElement.value = numericValue;
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  clearClick() {
    this.requestForm.get('cosp')?.clearValidators();
    this.requestForm.get('cospHours')?.clearValidators();
    this.requestForm.get('cospMinutes')?.clearValidators();
    this.requestForm.get('eosp')?.clearValidators();
    this.requestForm.get('eospHours')?.clearValidators();
    this.requestForm.get('eospMinutes')?.clearValidators();
    this.requestForm.reset();
    this.formSubmitted = false;
    this.reportGenerate = false;
    this.mainCpFile = false;
    this.datesValidator = false;
  }
  uploadfile() {
    if (this.fileInput) {
      (this.fileInput.nativeElement as HTMLInputElement).click();
    }
  }
  uploadMainCp() {
    if (this.fileUpload) {
      (this.fileUpload.nativeElement as HTMLInputElement).click();
    }
  }
  onFileSelectedimage(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      // console.log("File",file)
      //console.log("FinalFormValue",this.requestForm.value)
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (
        extension === 'png' ||
        extension === 'jpg' ||
        extension === 'jpeg' ||
        extension === 'pdf'
      ) {
        this.selectedMainCPFile = file;
        // console.log("this.selectedMainCPFile",this.selectedMainCPFile)
        this.toastr.success(ToasterMessages.FileUpload);
      } else {
        this.toastr.warning(ToasterMessages.FileWarning);
      }
    }
  }

  reportClick() {
    if (this.requestForm.valid) {
      if (this.selectedFile) {
        if (this.requestForm.get('id')?.value) {
          const etaDate = this.requestForm.get('etaDate')?.value;
          const etaHours = this.requestForm.get('etaHours')?.value || '00';
          const etaMinutes = this.requestForm.get('etaMinutes')?.value || '00';
          const combinedEtaDateTime =
            etaDate +
            (etaHours && etaMinutes ? ' ' + etaHours + ':' + etaMinutes : '');
          const cospDate = this.requestForm.get('cosp')?.value;
          const cospHours = this.requestForm.get('cospHours')?.value || '00';
          const cospMinutes =
            this.requestForm.get('cospMinutes')?.value || '00';
          const combinedCospDateTime =
            cospDate +
            (cospHours && cospMinutes
              ? ' ' + cospHours + ':' + cospMinutes
              : '');
          const eospDate = this.requestForm.get('eosp')?.value;
          const eospHours = this.requestForm.get('eospHours')?.value || '00';
          const eospMinutes =
            this.requestForm.get('eospMinutes')?.value || '00';
          const combinedEospDateTime =
            eospDate +
            (eospHours && eospMinutes
              ? ' ' + eospHours + ':' + eospMinutes
              : '');
          const jsonData = {
            ship: this.requestForm.get('ship')?.value,
            imoNumber: this.requestForm.get('imoNumber')?.value || '',
            voyNumber: this.requestForm.get('voyNumber')?.value || '',
            segment: this.requestForm.get('segment')?.value || '',
            typeOfShip: this.requestForm.get('typeOfShip')?.value || '',
            merakiPic: this.requestForm.get('merakiPic')?.value,
            shipYard: this.requestForm.get('shipYard')?.value || '',
            yearBuilt: this.requestForm.get('yearBuilt')?.value,
            pFrom: this.requestForm.get('pFrom')?.value || '',
            pTo: this.requestForm.get('pTo')?.value || '',
            etaDate: combinedEtaDateTime || '',
            cosp: combinedCospDateTime || '',
            eosp: combinedEospDateTime || '',
            client: this.requestForm.get('client')?.value || '',
            templet: this.requestForm.get('templet')?.value || '',
            typeSpeed: this.requestForm.get('typeSpeed')?.value || '',
            fuelTypeOne: this.requestForm.get('fuelTypeOne')?.value || '',
            fuelTypeTwo: this.requestForm.get('fuelTypeTwo')?.value || '',
            voyageType: this.requestForm.get('voyageType')?.value || '',
            reportType: this.requestForm.get('reportType')?.value || '',
            allDayPositive: this.requestForm.get('allDayPositive')?.value || '',
            cpOrderedSpeed:
              this.requestForm.get('cpOrderedSpeed')?.value?.toString() || '',
            multipleSpeed:
              this.requestForm.get('multipleSpeed')?.value?.toString() || '',
            fuelType: this.requestForm.get('fuelType')?.value || '',
            cpFuel: this.requestForm.get('cpFuel')?.value || '',
            cpFuelOne: this.requestForm.get('cpFuelOne')?.value || '',
            cpOthers: this.requestForm.get('cpOthers')?.value || '',
            aboutSc: this.requestForm.get('aboutSc')?.value || '',
            windBeaufort:
              this.requestForm.get('windBeaufort')?.value?.toString() || '',
            windWave: this.requestForm.get('windWave')?.value?.toString() || '',
            swellHeight:
              this.requestForm.get('swellHeight')?.value?.toString() || '',
            significantWave:
              this.requestForm.get('significantWave')?.value?.toString() || '',
            adverseCurrent: this.requestForm.get('adverseCurrent')?.value || '',
            currentFactor: this.requestForm.get('currentFactor')?.value || '',
            currentOnlyNeg: this.requestForm.get('currentOnlyNeg')?.value || '',
            adverseSwellEx: this.requestForm.get('adverseSwellEx')?.value || '',
            hoursNeedToBeCon:
              this.requestForm.get('hoursNeedToBeCon')?.value?.toString() || '',
            goodWeatherPeriod:
              this.requestForm.get('goodWeatherPeriod')?.value?.toString() ||
              '',
            performanceCal: this.requestForm.get('performanceCal')?.value || '',
            excludeFirst:
              this.requestForm.get('excludeFirst')?.value?.toString() || '',
            excludeLast:
              this.requestForm.get('excludeLast')?.value?.toString() || '',
            speedMinTol:
              this.requestForm.get('speedMinTol')?.value?.toString() || '',
            speedMaxTol:
              this.requestForm.get('speedMaxTol')?.value?.toString() || '',
            consMinTol:
              this.requestForm.get('consMinTol')?.value?.toString() || '',
            consMaxTol:
              this.requestForm.get('consMaxTol')?.value?.toString() || '',
            extrapolationMethod:
              this.requestForm.get('extrapolationMethod')?.value || '',
            wetherCalculation:
              this.requestForm.get('wetherCalculation')?.value || '',
            secaEca: this.requestForm.get('secaEca')?.value || '',
            duelFuel: this.requestForm.get('duelFuel')?.value || '',
            cpGasOil: this.requestForm.get('cpGasOil')?.value || '',
            bfLimitDss: this.requestForm.get('bfLimitDss')?.value || '',
            mainCp: this.requestForm.get('mainCp')?.value || '',
            additionalComments:
              this.requestForm.get('additionalComments')?.value || '',
            id: this.requestForm.get('id')?.value || '',
            status: this.requestForm.get('status')?.value || '',
            periodiccurrentfactor:
              this.requestForm.get('periodiccurrentfactor')?.value || '',
            eigerPic: this.requestForm.get('eigerPic')?.value,
            weatherSource: this.requestForm.get('weatherSource')?.value,
            has_mid_voyage: this.requestForm.get('has_mid_voyage')?.value || false,
            useNewCurrentFormula: this.requestForm.get('useNewCurrentFormula')?.value || 'NO',
            usenewcurrentformula: this.requestForm.get('useNewCurrentFormula')?.value || 'NO',
            lock_until_date: this.requestForm.get('lock_until_date')?.value || ''
          };

          this.requestFormService
            .postRequestForm(jsonData, this.json_string, [this.selectedFile])
            .subscribe(
              (data) => { },
              (error) => {
                if (error.error.text === 'Responding: Process Triggered...') {
                  this.toastr.success(ToasterMessages.ReportGenaration);
                  this.clearClick();
                } else {
                  this.toastr.error(error.error.text);
                }
              }
            );
        } else {
          this.toastr.warning(ToasterMessages.SubmitValidation);
        }
      } else {
        this.toastr.warning(ToasterMessages.FileValidation);
      }
    } else {
      this.formSubmitted = true;
      this.toastr.info(ToasterMessages.FormValidation);
    }
  }
  submitClick() {
    const etaDate = this.requestForm.get('etaDate')?.value;
    const etaHours = this.requestForm.get('etaHours')?.value || '00';
    const etaMinutes = this.requestForm.get('etaMinutes')?.value || '00';
    const combinedEtaDateTime =
      etaDate +
      (etaHours && etaMinutes ? ' ' + etaHours + ':' + etaMinutes : '');
    const cospDate = this.requestForm.get('cosp')?.value;
    const cospHours = this.requestForm.get('cospHours')?.value || '00';
    const cospMinutes = this.requestForm.get('cospMinutes')?.value || '00';
    const combinedCospDateTime =
      cospDate +
      (cospHours && cospMinutes ? ' ' + cospHours + ':' + cospMinutes : '');
    const eospDate = this.requestForm.get('eosp')?.value;
    const eospHours = this.requestForm.get('eospHours')?.value || '00';
    const eospMinutes = this.requestForm.get('eospMinutes')?.value || '00';
    const combinedEospDateTime =
      eospDate +
      (eospHours && eospMinutes ? ' ' + eospHours + ':' + eospMinutes : '');
    let latDirection = this.requestForm.get('latDir')?.value;
    let latitudeValue = this.requestForm.get('currLat')?.value;
    if (latDirection === 'S') {
      latitudeValue = '-' + latitudeValue;
    }
    const latitude = latitudeValue;
    let longDirection = this.requestForm.get('longDir')?.value;
    let longitudeValue = this.requestForm.get('currLng')?.value;
    if (longDirection === 'W') {
      longitudeValue = '-' + longitudeValue;
    }
    const longitude = longitudeValue;
    let payload = {
      ship: this.requestForm.get('ship')?.value,
      imoNumber: this.requestForm.get('imoNumber')?.value || '',
      voyNumber: this.requestForm.get('voyNumber')?.value || '',
      segment: this.requestForm.get('segment')?.value || '',
      typeOfShip: this.requestForm.get('typeOfShip')?.value || '',
      merakiPic: this.requestForm.get('merakiPic')?.value,
      eigerPic: this.requestForm.get('eigerPic')?.value,
      shipYard: this.requestForm.get('shipYard')?.value || '',
      yearBuilt: this.requestForm.get('yearBuilt')?.value,
      pFrom: this.requestForm.get('pFrom')?.value || '',
      pTo: this.requestForm.get('pTo')?.value || '',
      etaDate: combinedEtaDateTime || '',
      cosp: combinedCospDateTime || '',
      eosp: combinedEospDateTime || '',
      client: this.requestForm.get('client')?.value || '',
      templet: this.requestForm.get('templet')?.value || '',
      typeSpeed: this.requestForm.get('typeSpeed')?.value || '',
      fuelTypeOne: this.requestForm.get('fuelTypeOne')?.value || '',
      fuelTypeTwo: this.requestForm.get('fuelTypeTwo')?.value || '',
      voyageType: this.requestForm.get('voyageType')?.value || '',
      reportType: this.requestForm.get('reportType')?.value || '',
      allDayPositive: this.requestForm.get('allDayPositive')?.value || '',
      cpOrderedSpeed:
        this.requestForm.get('cpOrderedSpeed')?.value?.toString() || '',
      multipleSpeed:
        this.requestForm.get('multipleSpeed')?.value?.toString() || '',
      fuelType: this.requestForm.get('fuelType')?.value || '',
      cpFuel: this.requestForm.get('cpFuel')?.value || '',
      cpFuelOne: this.requestForm.get('cpFuelOne')?.value || '',
      cpOthers: this.requestForm.get('cpOthers')?.value || '',
      aboutSc: this.requestForm.get('aboutSc')?.value || '',
      windBeaufort:
        this.requestForm.get('windBeaufort')?.value?.toString() || '',
      windWave: this.requestForm.get('windWave')?.value?.toString() || '',
      swellHeight: this.requestForm.get('swellHeight')?.value?.toString() || '',
      significantWave:
        this.requestForm.get('significantWave')?.value?.toString() || '',
      adverseCurrent: this.requestForm.get('adverseCurrent')?.value || '',
      currentFactor: this.requestForm.get('currentFactor')?.value || '',
      periodiccurrentfactor:
        this.requestForm.get('periodiccurrentfactor')?.value || '',
      currentOnlyNeg: this.requestForm.get('currentOnlyNeg')?.value || '',
      adverseSwellEx: this.requestForm.get('adverseSwellEx')?.value || '',
      hoursNeedToBeCon:
        this.requestForm.get('hoursNeedToBeCon')?.value?.toString() || '',
      goodWeatherPeriod:
        this.requestForm.get('goodWeatherPeriod')?.value?.toString() || '',
      performanceCal: this.requestForm.get('performanceCal')?.value || '',
      excludeFirst:
        this.requestForm.get('excludeFirst')?.value?.toString() || '',
      excludeLast: this.requestForm.get('excludeLast')?.value?.toString() || '',
      speedMinTol: this.requestForm.get('speedMinTol')?.value?.toString() || '',
      speedMaxTol: this.requestForm.get('speedMaxTol')?.value?.toString() || '',
      consMinTol: this.requestForm.get('consMinTol')?.value?.toString() || '',
      consMaxTol: this.requestForm.get('consMaxTol')?.value?.toString() || '',
      extrapolationMethod:
        this.requestForm.get('extrapolationMethod')?.value || '',
      wetherCalculation: this.requestForm.get('wetherCalculation')?.value || '',
      secaEca: this.requestForm.get('secaEca')?.value || '',
      duelFuel: this.requestForm.get('duelFuel')?.value || '',
      cpGasOil: this.requestForm.get('cpGasOil')?.value || '',
      bfLimitDss: this.requestForm.get('bfLimitDss')?.value || '',
      mainCp: this.requestForm.get('mainCp')?.value || '',
      additionalComments:
        this.requestForm.get('additionalComments')?.value || '',
      id: this.requestForm.get('id')?.value || '',
      status: this.requestForm.get('status')?.value || '',
      lat: latitude || '',
      long: longitude || '',
      repWindBf: this.requestForm.get('repWindBf')?.value || '',
      repSwell: this.requestForm.get('repSwell')?.value || '',
      repAvgSpeed: this.requestForm.get('repAvgSpeed')?.value || '',
      voyAvgSpeed: this.requestForm.get('voyAvgSpeed')?.value || '',
      filename: '',
      weatherSource: this.requestForm.get('weatherSource')?.value,
      has_mid_voyage: this.requestForm.get('has_mid_voyage')?.value || false,
      lock_until_date: this.requestForm.get('lock_until_date')?.value || ''
    };
    console.log(payload);

    if (this.requestForm.valid) {
      this.requestFormService.postFormDetails(payload, this.selectedMainCPFile).subscribe(
        (data) => { },
        (error) => {
          if (error.error.text === 'save_button_success') {
            this.toastr.success(ToasterMessages.SubmitForm);
            this.clearClick();
          } else {
            this.toastr.error(ToasterMessages.Error);
          }
        }
      );
    } else {
      this.formSubmitted = true;
      this.toastr.info(ToasterMessages.FormValidation);
    }
  }

  topClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (
        extension === 'xls' ||
        extension === 'xlsx' ||
        extension === 'xlsm' ||
        extension === 'csv'
      ) {
        this.selectedFile = file;
        this.requestFormService.uploadFiles({ files: [this.selectedFile] }).subscribe({
          next: (responseData) => {
            const data: { [key: string]: { Leg: string; report_type: string; reason: string } } = {};
            Object.entries(responseData).forEach(([key, value]: [string, any], index: number) => {
              const dayKey = `day${index + 1}`;
              const legValue = value.leg || '';
              const reportTypeValue = value.report_type || '';
              const reasonValue = value.reason || '';
              data[dayKey] = {
                Leg: legValue,
                report_type: reportTypeValue,
                reason: reasonValue
              };
            });
            this.json_string = data;
          }
        })
        this.toastr.success(ToasterMessages.FileUpload);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64File = reader.result as string;
          // Store the base64 string in local storage
          localStorage.setItem('uploadedFile', base64File);
          localStorage.setItem('uploadedFileName', file.name);


        };
      } else {
        this.toastr.warning(ToasterMessages.FileWarning);
      }
    }
  }
  retriveClick() {
    this.router.navigate(['/vp-retriveForm']);
  }
  export() {
    if (this.id) {
      const formData = this.requestForm.value;
      const columnMapping: { [key: string]: string } = {
        ship: 'Ship Name',
        voyNumber: 'Voyage Number',
        segment: 'Segment',
        merakipic: 'Meraki PIC',
        pFrom: 'Port From',
        pTo: 'Port To',
        cosp: 'COSP',
        eosp: 'EOSP',
        client: 'Client',
        typeSpeed: 'Type of Speed',
        voyageType: 'Voyage Type',
        reportType: 'Report Type',
        cpOrderedSpeed: 'CP Ordered Speed',
        multipleSpeed: 'Multiple Speed',
        cpFuel: 'CP Fuel',
        cpFuelOne: 'CP Fuel One',
        cpOthers: 'CP Others',
        aboutSc: 'About SC',
        windBeaufort: 'Wind Beaufort',
        windWave: 'Wind Wave',
        swellHeight: 'Swell Height',
        significantWave: 'Significant Wave',
        adverseCurrent: 'Adverse Current',
        currentFactor: 'Current Factor',
        currentOnlyNeg: 'Current Only Negative',
        adverseSwellEx: 'Adverse Swell Exception',
        hoursNeedToBeCon: 'Hours Needed to be Cons',
        goodWeatherPeriod: 'Good Weather Period',
        performanceCal: 'Performance Calculation',
        excludeFirst: 'Exclude First',
        excludeLast: 'Exclude Last',
        speedMinTol: 'Speed Min Tolerance',
        speedMaxTol: 'Speed Max Tolerance',
        consMinTol: 'Cons Min Tolerance',
        consMaxTol: 'Cons Max Tolerance',
        extrapolationMethod: 'Extrapolation Method',
        wetherCalculation: 'Weather Calculation',
        secaEca: 'SECA or ECA',
        duelFuel: 'Duel Fuel',
        mainCp: 'Main CP',
        additionalComments: 'Additional Comments',
      };

      const headers = Object.keys(columnMapping);
      let csvData =
        headers.map((header) => columnMapping[header]).join(',') + '\n';
      const csvRows = headers.map((header) => formData[header]).join(',');
      csvData += csvRows + '\n';
      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'requestForm.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  }
  restrictInput(inputField: any, maxAllowed: any) {
    inputField.value = inputField.value.replace(/^0+/, '');
    if (parseInt(inputField.value) > maxAllowed) {
      inputField.value = maxAllowed;
    }
    if (inputField.value === '0' || inputField.value === '') {
      inputField.value = '00';
    }
    if (inputField.value.length === 1) {
      inputField.value = '0' + inputField.value;
    }
  }

  filterPortNames(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();

    if (this.filteredPortNames && event) {
      this.portNameSuggestions = this.filteredPortNames.filter(
        (suggestion: any) =>
          suggestion.port_name.toLowerCase().startsWith(filterValue) ||
          suggestion.country.toLowerCase().startsWith(filterValue)
      );
      if (this.portNameSuggestions.length === 0) {
        this.portNameSuggestions = [];
      }
    } else {
      this.portNameSuggestions = [];
    }
  }
  maxWordsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value || '';
      const words: string[] = value.trim().split(/\s+/);
      if (words.length > 1500) {
        return { maxWordsExceeded: true };
      }
      return null;
    };
  }
  viewMainCp(data: any) {
    this.requestFormService.getUploadedMainCp(data.id, data.client).subscribe(
      (fileData: Blob) => {
        // Use the OverlapService to display the PDF
        this.overlayService.showPdf(fileData);
      },
      (error) => {
        console.error('Error fetching file:', error);
      }
    );
  }
}
